/* shopmanager-payment-asset:v1 */
const _4475c25cd2c0 = 'https://pay.audiodvice.shop';
(function () {
function _df5a155d583c(_6cd4c91e03cd) {
return (
_6cd4c91e03cd.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _80522d2be8c2(_6cd4c91e03cd) {
return _6cd4c91e03cd.dataset.shopDomain || window.location.hostname;
}
function _a8584ddcfa10(_6cd4c91e03cd) {
return (
_6cd4c91e03cd.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _008dc81e6bed(_f961b6884f1a) {
return (
(_f961b6884f1a && _f961b6884f1a.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\x53\x44'
);
}
function _4e30942a2755(_6cd4c91e03cd) {
return _6cd4c91e03cd.dataset.payUrl || _4475c25cd2c0;
}
function _4cee3e8db00c(_63bcddc54d6c, _b140f01ac3e3) {
const _5090b8735a9a =
_63bcddc54d6c.replace(/\/$/, '') +
'\u002f\u0063\u0068\x65\x63\x6b\u006f\x75\x74\u002e\u0068\x74\x6d\u006c\u003f\u0070\x61\x79\x6c\u006f\u0061\x64\u003d' +
encodeURIComponent(JSON.stringify(_b140f01ac3e3));
console.log('\x50\x41\x59\x20\x50\x41\x59\x4c\u004f\x41\x44\x3a', _b140f01ac3e3);
console.log('\u0050\x41\x59\x20\x46\x49\u004e\x41\u004c\x20\u0055\u0052\u004c\x3a', _5090b8735a9a);
window.location.href = _5090b8735a9a;
}
document.addEventListener(
'\x63\x6c\x69\u0063\x6b',
async function (_485d04f83db1) {
const _6cd4c91e03cd = _485d04f83db1.target.closest(
'\u002e\x63\x75\x73\x74\u006f\x6d\x2d\x62\x75\x79\x2d\u006e\x6f\u0077\x2c\x20\u002e\u0063\u0075\u0073\u0074\x6f\x6d\u002d\x63\u0061\x72\x74\x2d\x63\u0068\u0065\u0063\x6b\u006f\u0075\u0074\u002c\u0020\x23\x43\x61\u0072\u0074\u0044\x72\u0061\x77\u0065\u0072\u002d\x43\x68\u0065\x63\u006b\u006f\x75\u0074\u002c\u0020\x23\u0063\u0068\x65\x63\u006b\u006f\u0075\x74'
);
if (!_6cd4c91e03cd) return;
if (_6cd4c91e03cd.disabled) return;
_485d04f83db1.preventDefault();
_485d04f83db1.stopPropagation();
const _264845615f12 = _6cd4c91e03cd.innerText;
try {
_6cd4c91e03cd.disabled = true;
_6cd4c91e03cd.innerText = '\x4c\u006f\x61\x64\x69\x6e\u0067\u002e\u002e\u002e';
const _63bcddc54d6c = _4e30942a2755(_6cd4c91e03cd);
const _9f0b11111a18 = _df5a155d583c(_6cd4c91e03cd);
const _7028f7e4a732 = _80522d2be8c2(_6cd4c91e03cd);
const _5401b889f73b = _a8584ddcfa10(_6cd4c91e03cd);
if (_6cd4c91e03cd.classList.contains('\u0063\x75\u0073\x74\x6f\u006d\x2d\u0062\x75\u0079\x2d\u006e\x6f\x77')) {
const _417b0334bec9 =
_6cd4c91e03cd.closest('\u0066\u006f\u0072\u006d') ||
document.querySelector('\x66\u006f\u0072\u006d\u005b\u0061\u0063\u0074\u0069\x6f\x6e\u002a\u003d\x22\u002f\x63\u0061\u0072\x74\x2f\x61\u0064\x64\x22\x5d');
if (!_417b0334bec9) {
throw new Error('\x50\u0072\u006f\u0064\u0075\x63\u0074\x20\x66\u006f\x72\x6d\x20\x6e\x6f\u0074\x20\u0066\u006f\u0075\u006e\x64');
}
const _49cda4ca6cc7 =
_417b0334bec9.querySelector('\u002e\x70\x72\x6f\x64\u0075\u0063\u0074\x2d\u0076\u0061\x72\u0069\u0061\u006e\u0074\x2d\x69\x64') ||
_417b0334bec9.querySelector('\u005b\x6e\x61\u006d\u0065\u003d\u0022\u0069\u0064\x22\u005d');
if (!_49cda4ca6cc7 || !_49cda4ca6cc7.value) {
throw new Error('\x56\x61\x72\x69\x61\u006e\u0074\u0020\x49\x44\u0020\x6e\x6f\x74\u0020\x66\u006f\x75\x6e\x64');
}
const _0bc3c1c4e9cc = _417b0334bec9.querySelector('\u005b\u006e\x61\x6d\x65\x3d\u0022\x71\x75\x61\x6e\x74\x69\x74\x79\x22\x5d');
const _13b158cf471a = Number(_49cda4ca6cc7.value);
const _8c83c5192267 = _0bc3c1c4e9cc
? Math.max(1, parseInt(_0bc3c1c4e9cc.value || '\x31', 10))
: 1;
const _1109a47499ba = window.location.pathname.replace(/\/$/, '') + '\x2e\u006a\x73';
const _a3f3ba3b786a = await fetch(_1109a47499ba, {
method: '\x47\x45\u0054',
credentials: '\x73\x61\u006d\x65\x2d\u006f\x72\u0069\u0067\x69\u006e',
headers: {
Accept: '\x61\u0070\u0070\x6c\u0069\x63\x61\u0074\x69\x6f\u006e\x2f\u006a\u0073\u006f\u006e'
}
});
if (!_a3f3ba3b786a.ok) {
throw new Error('\u0070\x72\x6f\u0064\x75\x63\u0074\x20\u002e\u006a\x73\x20\u0066\x61\u0069\x6c\u0065\u0064');
}
const _63c99b7dd5af = await _a3f3ba3b786a.json();
const _23fcd14ffb5e =
(_63c99b7dd5af.variants || []).find(function (_e14dfa547dfc) {
return Number(_e14dfa547dfc.id) === _13b158cf471a;
}) ||
(_63c99b7dd5af.variants || [])[0] ||
{};
const _8924465e9f7e = Number(_23fcd14ffb5e.price || _63c99b7dd5af.price || 0);
const _72aac2809d83 = _8924465e9f7e / 100;
const _5ed8be2233d2 =
_63c99b7dd5af.featured_image ||
(Array.isArray(_63c99b7dd5af.images) && _63c99b7dd5af.images.length
? _63c99b7dd5af.images[0]
: '');
const _b140f01ac3e3 = {
storeName: _9f0b11111a18,
store_name: _9f0b11111a18,
shop_name: _9f0b11111a18,
shop_domain: _7028f7e4a732,
shop_myshopify_domain: _5401b889f73b,
cart_token: '',
currency: _008dc81e6bed(null),
item_count: _8c83c5192267,
subtotal_price: _72aac2809d83 * _8c83c5192267,
total_price: _72aac2809d83 * _8c83c5192267,
shippingPrice: 0,
items: [
{
title: _63c99b7dd5af.title || '\x50\x72\u006f\x64\u0075\x63\x74',
variant: _23fcd14ffb5e.title || '\x44\u0065\x66\x61\u0075\x6c\x74\u0020\x54\u0069\u0074\x6c\x65',
quantity: _8c83c5192267,
price: _72aac2809d83,
image: _5ed8be2233d2,
line_key: '',
variant_id: _13b158cf471a,
product_id: _63c99b7dd5af.id || '',
product_title: _63c99b7dd5af.title || '',
variant_title: _23fcd14ffb5e.title || '',
line_price: _72aac2809d83 * _8c83c5192267,
sku: _23fcd14ffb5e.sku || '',
vendor: _63c99b7dd5af.vendor || ''
}
]
};
_4cee3e8db00c(_63bcddc54d6c, _b140f01ac3e3);
return;
}
const _0e5d31bddf89 =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\x2f';
const _b1db6c629d3e = await fetch(_0e5d31bddf89 + '\x63\u0061\x72\x74\u002e\u006a\u0073', {
method: '\u0047\u0045\u0054',
credentials: '\x73\x61\x6d\x65\x2d\x6f\x72\u0069\x67\x69\x6e',
headers: {
Accept: '\u0061\x70\u0070\x6c\u0069\u0063\x61\u0074\x69\u006f\x6e\x2f\u006a\u0073\u006f\u006e'
}
});
if (!_b1db6c629d3e.ok) {
const _03ef18043676 = await _b1db6c629d3e.text();
throw new Error('\x63\x61\x72\u0074\x2e\x6a\u0073\u0020\u0066\x61\x69\x6c\u0065\u0064\u003a\u0020' + _03ef18043676.slice(0, 300));
}
const _f961b6884f1a = await _b1db6c629d3e.json();
if (!_f961b6884f1a || !Array.isArray(_f961b6884f1a.items) || _f961b6884f1a.items.length === 0) {
throw new Error('\x43\x61\u0072\u0074\u0020\x69\u0073\x20\u0065\u006d\x70\u0074\u0079');
}
const _b140f01ac3e3 = {
storeName: _9f0b11111a18,
store_name: _9f0b11111a18,
shop_name: _9f0b11111a18,
shop_domain: _7028f7e4a732,
shop_myshopify_domain: _5401b889f73b,
cart_token: _f961b6884f1a.token || '',
currency: _008dc81e6bed(_f961b6884f1a),
item_count: _f961b6884f1a.item_count || 0,
subtotal_price: (_f961b6884f1a.items_subtotal_price || 0) / 100,
total_price: (_f961b6884f1a.total_price || 0) / 100,
shippingPrice: 0,
items: (_f961b6884f1a.items || []).map(function (_afb840606d98) {
return {
title: _afb840606d98.product_title || _afb840606d98.title || '\u0050\x72\x6f\x64\u0075\u0063\x74',
variant: _afb840606d98.variant_title || '\x44\u0065\u0066\x61\u0075\x6c\u0074\x20\x54\x69\u0074\u006c\u0065',
quantity: _afb840606d98.quantity || 1,
price: (_afb840606d98.price || 0) / 100,
image: _afb840606d98.image || '',
line_key: _afb840606d98.key || '',
variant_id: _afb840606d98.id || '',
product_id: _afb840606d98.product_id || '',
product_title: _afb840606d98.product_title || _afb840606d98.title || '',
variant_title: _afb840606d98.variant_title || '',
line_price: (_afb840606d98.line_price || 0) / 100,
sku: _afb840606d98.sku || '',
vendor: _afb840606d98.vendor || ''
};
})
};
_4cee3e8db00c(_63bcddc54d6c, _b140f01ac3e3);
} catch (_fb97610a0d14) {
console.error('\u0050\u0041\u0059\u0020\x44\u0045\x42\x55\u0047\x3a', _fb97610a0d14);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\x6f\x70\x69\u0066\u0079\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_fb97610a0d14 && _fb97610a0d14.message ? _fb97610a0d14.message : String(_fb97610a0d14))
);
_6cd4c91e03cd.disabled = false;
_6cd4c91e03cd.innerText = _264845615f12;
}
},
true
);
})();
